import React, { useCallback, useMemo } from "react"
import { getIn } from "formik"
import { Checkbox, Switch } from "@mui/material"
import { includesArray } from "shared/lib"

const CheckboxGroupComponent = ({
  field,
  form,
  onBeforeChange = null,
  variant = "checkbox",
  ...props
}) => {
  const { values, setFieldValue, setFieldTouched } = form
  const groupValue = getIn(values, field.name)
  const checkboxValue = props.value
  const customOnChange = props.onChange

  const handleChange = useCallback(
    async (_, checked) => {
      let change = false
      try {
        if (onBeforeChange) {
          await onBeforeChange(checked)
        }
        change = true
      } catch {
        change = false
      }

      if (change) {
        if (checked) {
          const set = new Set(groupValue)
          checkboxValue.forEach((v) => set.add(v))
          setFieldValue(field.name, Array.from(set))
        } else {
          setFieldValue(
            field.name,
            groupValue.filter(
              /** @param {string | number} v */
              (v) => !checkboxValue.includes(v)
            )
          )
        }
        setFieldTouched(field.name, true)
        if (customOnChange) {
          customOnChange(checked)
        }
      }
    },
    [
      setFieldTouched,
      field.name,
      setFieldValue,
      groupValue,
      checkboxValue,
      customOnChange,
      onBeforeChange
    ]
  )

  const checked = useMemo(() => {
    return groupValue && includesArray(groupValue, checkboxValue)
  }, [groupValue, checkboxValue])

  const Component = variant === "switch" ? Switch : Checkbox

  return <Component {...props} checked={checked} onChange={handleChange} />
}

export const MultiCheckboxGroup = React.memo(CheckboxGroupComponent)
